import React, { useEffect, useState } from "react";
import '../../../CSS/TablaHerramientas.css'
import {BsFiletypePdf, BsPlus} from "react-icons/bs";
import {getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import moment from "moment/moment";
import { calibriBold,calibriRegular } from "../../../Fonts/font";
import autoTable from 'jspdf-autotable'
import { jsPDF } from "jspdf";
import watermark from "../../../Img/watermark.png"
import { FaArrowLeftLong } from "react-icons/fa6";
import { getApi, postApi } from "../../../Conexiones/Models";
import { closeAlert, errorMessage, errorToast, successToast, warningToast } from "../../../Utils/AlertMessage";
import { Button, CloseButton, Modal } from "react-bootstrap";
import { PropagateLoader } from "react-spinners";
import Loading from '../../../Utils/Loading';

function GastosTramitesObra(){
    const navigate = useNavigate();
    const obraId = parseInt(sessionStorage.getItem("obra"));
    const [gastos, setGastos] = useState([]);
    const [tablaGastos, setTablaGastos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [totalTra, setTotalTra] = useState(0);
    const [direccion,setDireccion] = useState('');
    const [obra,setObra] = useState('');
    const [cliente,setCliente] = useState('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const [isSaving, setSaving] = useState(false);
    const [isLoading,setIsLoading]=useState(false);

    var registros = []
    var totalSemana='';

    useEffect( ()=>{
        const getGastos = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,30);
            if(permiso){ 
                const endpoint = 'gastos-tramites-obra-ini/'+obraId;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setGastos(res.data[0].gastos);
                        setTablaGastos(res.data[0].gastos);
                        setTotalTra(res.data[0].total);
                        setObra(res.data[0].obra);
                        setDireccion(res.data[0].direccion);
                        setCliente(res.data[0].cliente);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getGastos();
    }, [navigate,idUsuario,obraId]);

    const getGastos = async () =>{
        const endpoint = 'gastos-tramites-obra-ini/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setGastos(res.data[0].gastos);
                setTablaGastos(res.data[0].gastos);
                setTotalTra(res.data[0].total);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2);
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const traTotal = formato(totalTra)
    
    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/')
    }
   
    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaGastos.filter((elemento)=> {
            if(elemento.nombreTramite.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda
        });
        setGastos(resBusqueda);
    }

    /* AGREGAR GASTO INICIO */
    const [concepto,setConcepto] = useState('');
    const [cantidad,setCantidad] = useState('');
    const [precio,setPrecio] = useState('');
    const [fechaGT,setFechaGT] = useState('');
    const [tramites,setTramites] = useState([]);
    const [showGT, setShowGT] = useState(false);
    const handleCloseGT = () => {
        closeAlert();
        setShowGT(false);
        setFechaGT('');
        setPrecio('');
        setCantidad('');
        setConcepto('');
    }
    const handleShowGT = async () =>{
        await getTramites();
        setShowGT(true);
    }
    const getFecha = () =>{
        const date= moment (new Date());
        return(date.tz('America/Mexico_City').format('YYYY-MM-DD'))
    }
    const getTramites = async () =>{
        const endpoint = 'tramites/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setTramites(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const validar = async () =>{
        warningToast('CAMPOS VACIOS','RELLENE LOS CAMPOS OBLIGATORIOS')
    }
    const confirmar = async () =>{
        warningToast('¿ESTAS SEGURO DE REGISTRAR ESTE GASTO?','',true)
        .then(async (result) => {        
            if (result.isConfirmed) {
                setSaving(true);
                const idAd = parseInt(concepto);
                const cant = parseInt(cantidad);
                const price = parseFloat(precio);
                const endpoint = 'gastos-tramites-obra/';
                const data = {idObra:obraId, idTramite:idAd, cantidad:cant, precio:price, fecha:fechaGT};
                const res = await postApi(endpoint,data);
                if(res.status === 1){
                    if(res.data.message==="SE GUARDÓ EL REGISTRO CORRECTAMENTE"){
                        handleCloseGT();
                        getGastos();
                        successToast("AGREGADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
                setSaving(false);
            }
        })
    }
    /* AGREGAR GASTO FIN */

    //MODAL DESCARGANDO
    const [showDescargar, setShowDescargar] = useState(false);
    const handleCloseDescarg = () => {
        setShowDescargar(false);
    }
    const handleShowDescarg = () =>{
        setShowDescargar(true);
    }
    const getRegistros = async () =>{
        handleShowDescarg();
        const endpoint = 'gastos-tramites-pdf/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                registros=res.data[0].lista
                totalSemana=res.data[0].totalSemana
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        if(registros.length===0){
            warningToast('NO EXISTEN REGISTROS DE LA FECHA SELECCIONADA');
        }else{
            descargar(registros,totalSemana);
        }
        handleCloseDescarg();
    }

    const descargar = (lista,totalSemana) => {
        //setRegistros([])
        //getRegistros(fechaSelect);
        //console.log(registros)
        //registros.length = 0 //limpiar lista
        var date = moment( new Date());
        const fecha = date.tz('America/Mexico_City').format('DD/MM/YYYY')
        //const fecha2 = date.tz('America/Mexico_City').format('DDMMYY')
        //console.log(fecha)
        var doc = new jsPDF({format: 'letter',orientation:"portrait"});
        var company_logo = {
            w: 30,
            h: 20
        };

        var startY=0;
        //IMAGEN
        var imgData ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
        doc.addImage(imgData,'JPEG',10,25,company_logo.w,company_logo.h);
        //console.log(doc.internal.pageSize.getHeight())
        var logo = new Image();
        logo.src = watermark;
        doc.addImage(logo, 'JPEG',32.945, 89.7,150,100);
        //TITULO
        doc.addFileToVFS("calibri-bold.ttf", calibriBold);
        doc.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
        doc.setFont("calibri-bold","bold");
        doc.setFontSize(18);
        doc.setTextColor("#002060")
        doc.text("CONTROL GASTOS DE TERRENO Y TRAMITES", doc.internal.pageSize.getWidth() / 2, 15, null, 'center');
        //LINEA #1
        doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
        doc.setLineWidth(2.5);    
        doc.line(10, 18, 205, 18); // vertical line    
        //console.log(doc.internal.pageSize.getWidth())
        //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
        doc.setFont("calibri-bold","bold");
        doc.setFontSize(10);
        doc.setTextColor("black")
        doc.text("OBRA:", 70, 28, null, 'right');
        doc.text("UBICACIÓN:", 70, 33, null, 'right');
        doc.text("CIUDAD:", 70, 38, null, 'right');
        doc.text("ESTADO:", 70, 43, null, 'right');
        doc.text("FECHA:", 150, 45, null, 'right');
        //TIPO DE LETRA REGULAR
        doc.addFileToVFS("calibri-regular.ttf", calibriRegular);
        doc.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
        doc.setFont("calibri-regular","normal");
        doc.setFontSize(10);
        doc.text(obra.toUpperCase(), 75, 28, null, 'left');
        doc.text(direccion.toUpperCase(), 75, 33, null, 'left');
        doc.text("CHILPANCINGO", 75, 38, null, 'left');
        doc.text("GUERRERO", 75, 43, null, 'left');
        //FECHA DESCARGA
        doc.setFont("calibri-regular","normal");
        doc.text(fecha, 165, 45, null, 'center');
        //LINEA #2
        doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
        doc.setLineWidth(1.0);    
        doc.line(10, 53, 205, 53); // vertical line  
               
        //TABLA
        var rows = lista;
        //console.log(rows)
        //const last = rows[rows.length-1];
        //const totalSemana=last.totalSemana;
        let datos = []
        rows.forEach((element) => {
            datos.push([element.nombreTramite.toUpperCase(),moment(element.fecha).format("DD-MM-YYYY")
            ,element.cantidad,
            '$ '+formato(element.precio),
            '$ '+formato(element.total)])
        });
        //console.log(datos)
        //TABLA
        autoTable(doc,
            {head: [['CONCEPTO','FECHA','CANTIDAD','PRECIO','SUBTOTAL']],
            body:datos , tableWidth: 'wrap',
            margin: {right:10, left:10 },
            headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
            startY: 60,
            theme:"plain",
            columnStyles: {
                0: {halign:"left",cellWidth: 50},
                1: {halign:"center",cellWidth: 40},
                2: {halign:"center",cellWidth: 25},
                3: {halign:"right",cellWidth: 40},
                4: {halign:"right",cellWidth: 40}
            }
        })
        startY=doc.lastAutoTable.finalY;
        //LINEA AL FINAL DE LA TABLA
        doc.setDrawColor("black", 0, 0); // draw red lines    
        doc.setLineWidth(1.0);    
        doc.line(10, startY, 205, startY); // vertical line  
        //TOTALES
        doc.setFont("calibri-bold","bold");
        doc.setFontSize(12);
        doc.setTextColor("black")
        doc.text("TOTAL", 160, startY+15); 
        doc.text("$ "+formato(totalSemana), 204, startY+15,"right");  
        //FOOTER
        /*function addFooters() {
            const pageCount = doc.internal.getNumberOfPages();
            for(var i = 1; i <= pageCount; i++) {
                doc.setTextColor("#808080")
                doc.text("7471683077 | inmobiliariacrosmo@gmail.com | chalio_37@hotmail.com",
                doc.internal.pageSize.getWidth() / 2 - (doc.getTextWidth("7471683077 | inmobiliariacrosmo@gmail.com | chalio_37@hotmail.com") / 2),
                doc.internal.pageSize.getHeight() - 20,
                { baseline: 'top' });

                doc.text("Circuito Deportivo Mza.1 Lote 2,Col Unidad Deportiva,C.P.39074",
                doc.internal.pageSize.getWidth() / 2 - (doc.getTextWidth("Circuito Deportivo Mza.1 Lote 2,Col Unidad Deportiva,C.P.39074") / 2),
                doc.internal.pageSize.getHeight() - 15,
                { baseline: 'top' });
            }
        }*/
        //addFooters()
        //var blob = doc.output("blob");
        //window.open(URL.createObjectURL(blob));
        doc.save('GASTOS TRAMITES GENERAL -'+obra+'.pdf');
    }

    return(
        <div className="tablaHerramientas">
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">CONTROL DE GASTOS DE TERRENO Y TRAMITES</label>
                    </div>
                    <div >
                        <div>
                            <label className='text-uppercase'><strong>NOMBRE DE LA OBRA:</strong> {obra}</label>
                        </div>
                        <div>
                            <label className='text-uppercase'><strong>DUEÑO:</strong> {cliente}</label>
                        </div>
                    </div>
                    <div className='divboton' style={{margin:'5px 0'}}>                                                                                             
                        <div className='boton' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={handleShowGT} type="button">
                                <label className="agregar">REGISTRAR GASTO</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>

                            <button title='DESCARGAR'  onClick={()=> getRegistros()}   style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button">
                            <BsFiletypePdf style={{fontSize:'25px'}}/> <label className="agregar">DESCARGAR</label>
                            </button>

                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>
                        </div>
                    </div>
                    <div className='divboton mb-2' style={{textAlign:'right'}}>
                        <div>
                            <strong><h5>{traTotal === 'NaN' ? ("TOTAL: $"+0): "TOTAL: $"+traTotal }</h5></strong>
                        </div>
                    </div>
                    { gastos.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                        <div className="caja-asistencia" >
                            <div className="table tabla" >
                                <table className="table  text-uppercase" >
                                    <thead >
                                        <tr >
                                            <th>CONCEPTO</th>
                                            <th>CANTIDAD</th>
                                            <th>PRECIO</th>
                                            <th>TOTAL</th>
                                            <th>FECHA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {gastos.map(g =>{
                                            return(
                                                <tr key={g.idGasto}>
                                                    <td>{g.nombreTramite}</td>
                                                    <td>{g.cantidad}</td>
                                                    <td>$ {formato(g.precio)}</td>
                                                    <td>$ {formato(g.total)}</td>
                                                    <td>{moment(g.fecha).format("DD-MM-YYYY")}</td>
                                                </tr>                             
                                            )
                                        })}                        
                                    </tbody>
                                </table>
                            </div>           
                        </div>
                    )}

                    {/*AGREGAR GASTO TRAMITE*/}     
                    <Modal  show={showGT}  onHide={handleCloseGT}  id="modal-agregar-tramite" backdrop="static" keyboard={false}>
                        <Modal.Header className=' btncolor' style={{textAlign:"center"}}>
                            <Modal.Title>REGISTRAR GASTO MAQUINARIA O EQUIPO</Modal.Title>
                            <CloseButton onClick={handleCloseGT} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left',height:'60vh', overflowY:"scroll" }}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <div className="mb-3" style={{textAlign:'center'}}>
                                <h5 className="modal-title text-uppercase " id="exampleModalLabel">{obra}</h5>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">CONCEPTO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <select className="form-control" required onChange={e => setConcepto(e.target.value)}>
                                    <option >--Seleccione una opción--</option>
                                    {tramites.map(t => {
                                        return(
                                            <option key={t.idTramite} value={t.idTramite}>{t.nombreTramite}</option>
                                        )
                                    })}                                
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">CANTIDAD <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="number" min={0} className="form-control"  id="exampleFormControlInput1" required
                                onChange={e => setCantidad(e.target.value) }/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">PRECIO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="number"  min={0} className="form-control"  id="exampleFormControlInput2" step="any" required
                                onChange={e => setPrecio(e.target.value) }/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="date" className="form-control" max={getFecha()} id="exampleFormControlInput1" required
                                onChange={e => setFechaGT(e.target.value) }/>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary"  onClick={handleCloseGT} >CANCELAR</Button>
                            {concepto === '' | cantidad === '' | precio === '' | fechaGT === '' ? (
                                <Button type="button" className="btn btncolor" onClick={validar} >ACEPTAR</Button>
                            ):(
                                isSaving===true?
                                <Button className="btn btn-primary" type="button" disabled >
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </Button>:
                                <Button type="button" className="btn btn-light btncolor" onClick={confirmar} >ACEPTAR</Button>
                            )}                                        
                        </Modal.Footer>
                    </Modal>

                    {/*DESCARGANDO....*/}
                    <Modal  show={showDescargar}  onHide={handleCloseDescarg} centered >
                        <Modal.Body  style={{textAlign:'center', marginTop:'15px',marginBottom:"5%"}}>
                            <div>
                                <h3>DESCARGANDO</h3>
                            </div>
                            <div style={{textAlign:'center', marginTop:'15px'}}>
                                <PropagateLoader color="#1A2E4F"/>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default GastosTramitesObra;